module.exports = __webpack_public_path__ + "media/favicon/android-chrome-384x384-b2b35fd4.png";